import { render, staticRenderFns } from "./customsearch.vue?vue&type=template&id=984bd01c&scoped=true&"
import script from "./customsearch.vue?vue&type=script&lang=js&"
export * from "./customsearch.vue?vue&type=script&lang=js&"
import style0 from "./customsearch.vue?vue&type=style&index=0&id=984bd01c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "984bd01c",
  null
  
)

export default component.exports